import React, { useEffect, useState } from "react";
import { ArrowUp } from "@phosphor-icons/react";

/**
 * ScrollTopButton
 * ───────────────
 * A subtle floating "back to top" button that appears after the user scrolls
 * past the fold. Smooth scrolls to top on click.
 */
export default function ScrollTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      type="button"
      aria-label="Back to top"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      data-testid="scroll-top-btn"
      className={`fixed bottom-24 right-6 z-40 w-11 h-11 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
      style={{ background: "#0F2A6E", color: "#FFFFFF" }}
    >
      <ArrowUp size={17} weight="bold" />
    </button>
  );
}
